import { microsoftAuthApiRef } from '@backstage/core-plugin-api';

export const providers = [
    {
        id: 'microsoft-auth-provider',
        title: 'Microsoft',
        message: 'Sign-In using MS Azure AD',
        apiRef: microsoftAuthApiRef,
    },
];